import { IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px'
  },
  closeButton: {
    color: theme.iconColor
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    top: '19px'
  }
});
const Header = ({ onClose, title, classes }) => {
  return (
    <div id="dialogHeader" className={classes.headerContainer}>
      <div className={classes.title}>{title}</div>
      {onClose ? (
        <IconButton onClick={onClose} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(Header);
